export const category=[
    {
        id:1,
        name:"Products",
        apicall:"products",
        count:100,
        fields:[
            {
                id:1,
                name:"id",
                uni:"1"
            },
            {
                id:2,
                name:"title",
                uni:"2"

            },
            {
                id:3,
                name:"description",
                uni:"3"
            },
            {
                id:4,
                name:"price",
                uni:"4"
            },
            {
                id:5,
                name:"discountPercentage",
                uni:"5"
            },
            {
                id:6,
                name:"rating",
                uni:"6"
            }, {
                id:7,
                name:"stock",
                uni:"7"
            }
            , {
                id:8,
                name:"brand",
                uni:"8"
            }
            , {
                id:9,
                name:"category",
                uni:"9"
            }, {
                id:10,
                name:"thumbnail",
                uni:"10"
            }
            , {
                id:11,
                name:"images",
                uni:"11"
            }
        ]

        

    },
    {
        id:2,
        name:"Carts",
        apicall:"carts",
        count:20,
        fields:[
            {
                id:1,
                name:"id",
                uni:"12"

            },
            {
                id:2,
                name:"products",
                uni:"13"
            },
            {
                id:3,
                name:"total",
                uni:"81"
            },
            {
                id:4,
                name:"totalProducts",
                uni:"82"
            },
            {
                id:5,
                name:"totalQuantity",
                uni:"83"
            },
            {
                id:6,
                name:"userId",
                uni:"84"
            },
            {
                id:7,
                name:"discountedTotal",
                uni:"88"
            },
        ]
    },
    {
        id:3,
        name:"Users",
        apicall:"users",
        count:100,
        fields:[
            {
                id:1,
                name:"id",
                uni:"20"
            },
            {
                id:2,
                name:"firstName",
                uni:"21"
            },
            {
                id:3,
                name:"lastName",
                uni:"22"
            },
            {
                id:4,
                name:"maidenName",
                uni:"23"
            },
            {
                id:5,
                name:"age",
                uni:"24"
            },
            {
                id:6,
                name:"gender",
                uni:"25"
            }, {
                id:7,
                name:"email",
                uni:"26"
            }
            , {
                id:8,
                name:"phone",
                uni:"27"
            }
            , {
                id:9,
                name:"username",
                uni:"28"
            }, {
                id:10,
                name:"password",
                uni:"29"
            }
            , {
                id:11,
                name:"birthDate",
                uni:"30"
            }
            ,{
                id:12,
                name:"image",
                uni:"31"
            },
            {
                id:13,
                name:"bloodGroup",
                uni:"32"
            },{
                id:14,
                name:"height",
                uni:"33"
            }
            ,{
                id:15,
                name:"weight",
                uni:"34"
            }
            , {
                id:16,
                name:"eyeColor",
                uni:"35"
            }, {
                id:17,
                name:"hair",
                uni:"36"
            }, {
                id:18,
                name:"domain",
                uni:"37"
            },
            , {
                id:19,
                name:"address",
                uni:"38"
            }
            , {
                id:20,
                name:"bank",
                uni:"39"
            }
            , {
                id:21,
                name:"company",
                uni:"40"
            }
            , {
                id:22,
                name:"ip",
                uni:"61"
            }
            , {
                id:23,
                name:"ein",
                uni:"62"
            }
            , {
                id:24,
                name:"ssn",
                uni:"63"
            }
            , {
                id:25,
                name:"university",
                uni:"64"
            }
            , {
                id:25,
                name:"userAgent",
                uni:"65"
            }
        ]

    },
    {
        id:4,
        name:"Todos",
        apicall:"todos",
        count:150,
        fields:[
            {
                id:1,
                name:"id",
                uni:"41"
            },
            {
                id:2,
                name:"todo",
                uni:"42"
            },
            {
                id:3,
                name:"completed",
                uni:"43"
            },
            {
                id:4,
                name:"userId",
                uni:"45"
            }
        ]
    }
]

export const category1=[
    {
        id:1,
        name:"Products",
        apicall:"products",
        count:100,
    },
    {
        id:3,
        name:"Users",
        apicall:"users",
        count:100,
    }
]